import PropTypes from 'prop-types'
import React from 'react'
import cx from 'classnames'

import { getReserveParameterByKey } from 'helpers/reserves'

import styles from './TableRow.scss'

export const TableRow = ({
    rowIndex,
    selectedRow,
    columns,
    bonus,
    setTableColumnsRefs,
    columnsWidthConfig,
}) => {
    return (
        <div
            className={cx(
                styles.tr,
                (rowIndex < selectedRow) && styles.tr__previous,
                (rowIndex === selectedRow) && styles.tr__selected,
                (rowIndex === selectedRow + 1) && styles.tr__next,
            )}
        >
            {columns.map((column) => {
                const { dataIndex, classNames = {}, align, isCalculatedWidth } = column
                const value = getReserveParameterByKey(bonus, dataIndex)
                return (
                    <div
                        key={dataIndex}
                        className={cx(
                            styles.td,
                            styles.td__right || (align && styles[`td__${align}`]),
                            isCalculatedWidth && styles.td__calculatedWidth,
                            classNames.td,
                        )}
                        ref={el => setTableColumnsRefs(el, dataIndex)}
                        style={{ '--cell-width': `${columnsWidthConfig[dataIndex]}px` }}
                    >
                            {column.render ? column.render(value) : value}
                    </div>
                )
            })}
        </div>
    )
}

TableRow.propTypes = {
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.node.isRequired,
            dataIndex: PropTypes.string.isRequired,
            render: PropTypes.func,
        })
    ).isRequired,
    selectedRow: PropTypes.number,
    rowIndex: PropTypes.number.isRequired,
    bonus: PropTypes.object.isRequired,
    setTableColumnsRefs: PropTypes.func.isRequired,
    columnsWidthConfig: PropTypes.object.isRequired,
}

export default TableRow



// WEBPACK FOOTER //
// ./components/BaseBonusInfoTable/components/TableRow/TableRow.jsx